import { client } from './client';

class cityObjectApi {
    static async search(model) {
        if (typeof model !== "object") {
            model = {
                page: 1,
                limit: 25
            }
        }
        let response = await client.post('/city_objects', model);
        return response.data;
    }


    static async create(data) {
        let objectType = await client.put('/city_objects/', data);
        return objectType.data;
    }

    static async checkForDuplicates(data) {
        let objectType = await client.post('/city_objects/check', data);
        return objectType.data;
    }

    static async get(id) {
        let objectType = await client.get('/city_objects/' + id);
        return objectType.data;
    }

    static async getMultiple(id) {
        let objectType = await client.get('/city_objects/multiple/' + id);
        return objectType.data;
    }

    static async update(data) {
        let result = await client.patch('/city_objects/', data);
        return result.data;
    }

    static async updateTree(data) {
        let result = await client.patch('/city_objects/update_tree/', data);
        return result.data;
    }

    static async delete(id) {
        let result = await client.delete('/city_objects/' + id);
        return result.data;
    }

    static async getCityObjectFilters() {
        let cityObjectFilters = await client.get('/city_objects/filters');

        return cityObjectFilters.data;
    }

    /**
     * Get filter options for object search in private part
     * @returns {Promise<any>}
     */
    static async getSearchFilters() {
        let response = await client.get('/city_objects/search_filters');
        return response.data;
    }

    /**
     * Get filter options for object search in private part
     * @param types
     * @returns {Promise<any>}
     */
    static async getElementsByType(types = []) {
        let response = await client.post('/city_objects/search_elements', { types });
        return response.data;
    }

    /**
     * Search city objects by filter in private part for table view
     * @param filter
     * @returns {Promise<any>}
     */
    static async searchByFilterForTable(filter = {}) {
        let response = await client.post('/city_objects/search_by_filter_for_table', { filter });
        return response.data;
    }

    /**
     * Search city object layers (types) by filter in private part for map view
     * @param filter
     * @returns {Promise<any>}
     */
    static async searchLayersByFilterForMap(filter = {}) {
        let response = await client.post('/city_objects/search_layers_by_filter_for_map', { filter });
        return response.data;
    }

    static async getForSelectList() {
        let cityObjects = await client.get('/city_objects/for_select');

        return cityObjects.data;
    }

    static async getRelatedObjects(id) {
        let response = await client.get('/city_objects/' + id + '/related_objects');
        return response.data;
    }

    static async updateParentField(id,model) {
        let response = await client.post('/city_objects/update_parent_field/' + id, model);
        return response.data;
    }

    /**
     * Update object files
     * @param id
     * @param data
     * @returns {Promise<any>}
     */
    static async updateFiles(id, data) {
        let response = await client.post('/city_objects/' + id + '/files', data);
        return response.data;
    }

    /**
     * Update default object image
     * @param objectId
     * @param imageId
     * @returns {Promise<any>}
     */
    static async setDefaultImage(objectId, imageId) {
        let response = await client.patch('/city_objects/' + objectId + '/files/' + imageId);
        return response.data;
    }

    /**
     * Delete object file or image
     * @param objectId
     * @param fileId
     * @returns {Promise<*>}
     */
    static async deleteFile(objectId, fileId) {
        let response = await client.delete('/city_objects/' + objectId + '/files/' + fileId);
        return response.data;
    }

    static async publicShow(id) {
        let response = await client.get('/city_objects/' + id + '/public');
        return response.data;
    }

    static async getByMapFeatures(data) {
        let response = await client.post('/city_objects/search_by_map_features', data);
        return response.data;
    }

    static async getByMapFeaturesV2(data) {
        let response = await client.post('/city_objects/search_by_map_features_v2', data, { timeout: 3000000 });
        return response.data;
    }

    /**
     * @param id
     * @param latitude
     * @param longitude
     * @returns {Promise<*>}
     */
    static async contains(id, latitude, longitude) {
        let response = await client.get('/city_objects/object/' + id
            + '?latitude=' + latitude + '&longitude=' + longitude);

        return response.data;
    }

    /**
     * Search city objects in private part for maintenance filter
     * @param filter
     * @returns {Promise<any>}
     */
    static async searchForMaintenanceFilter(filter = {}) {
        let response = await client.post('/city_objects/search_for_maintenance_filter', { filter });
        return response.data;
    }

    /**
     * Export city objects to file
     * @returns {Promise<any>}
     * @param ids
     * @param type
     */
    static async exportToFile(ids, type) {
        let response = await client.post('/city_objects/export', { ids, type });
        return response.data;
    }

    /**
     * Check export city objects to file
     * @returns {Promise<any>}
     * @param id
     */
    static async checkExportToFile(id) {
        let response = await client.get('/city_objects/export_check', { params: { id } });
        return response.data;
    }
    static async addElementToObjectFromMap(data) {
        let response = await client.post('city_objects/add_element_from_map', data)
        return response.data
    }
    static async getByXY(data) {
        let response = await client.post('city_objects/get_by_x_y', data)
        return response.data
    }
    static async getClosestOfTypeByXY(data) {
        let response = await client.post('city_objects/get_closest_type_by_x_y', data)
        return response.data
    }
    static async byCoordinates(coordinates) {
        let response = await client.get('city_objects/by_coordinates/TKVR', { params: { coordinates } })
        return response.data
    }
}

export default cityObjectApi;
